import {
  SHOW_SNACKBAR,
  REMOVE_SNACKBAR,
  ShowSnackbarPayload,
  RemoveSnackbarPayload,
  SnackbarActionTypes,
} from "./SnackbarTypes";

export const showSnackbar = (
  payload: ShowSnackbarPayload,
): SnackbarActionTypes => ({
  type: SHOW_SNACKBAR,
  payload,
});

export const removeSnackbar = (
  payload: RemoveSnackbarPayload,
): SnackbarActionTypes => ({
  type: REMOVE_SNACKBAR,
  payload,
});
